module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("huvon"))).then(() => parcelRequire('9Lwss'));